class UnsubscribeMindboxForm extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback () {
		this.initElements();
		this.initEvents();
		this.getTicket();
		this.getSubscribtions();
	}

	initElements() {
		this.form = this.querySelector("[data-unsubscribe-form]");
		this.submitButton = this.querySelector("[data-unsubscribe-button]");
		this.statusMessages = this.querySelector("[data-unsubscribe-form-status-message]");
		this.formField = this.querySelector("[data-collect-form-field]");
		this.topicsList = this.querySelector("[data-topics-list]");

		this.topicNames = {
			"personalEu": "Personalized offers",
			"collectionEu": "Thematic selections",
			"childrenEu": "Kids",
			"secretEu": "Secrets of Unidragon",
			"promoEu": "Discounts and promotions",
			"newEu": "New products",
			"eventEu": "Company news"
		}
	}

	initEvents() {
		if (this.form) {
			this.form.addEventListener("submit", (event) => {
				event.preventDefault();
				this.sendData();
			});
		}
	}
	sendData() {
		if (!this.ticket) {
			return null;
		}

		this.updatedSubscribtions = {
			customer: {
				authenticationTicket: `${this.ticket}`,
				subscriptions: []
			}
		}

		const checkboxesForUnsubscribe = this.form.querySelectorAll('input[type="checkbox"]:checked');
		if (!checkboxesForUnsubscribe.length) {
			return null;
		}

		checkboxesForUnsubscribe.forEach(checkbox => {
			this.updatedSubscribtions.customer.subscriptions.push({
				brand: "UnidragonEu",
				pointOfContact: "Email",
				topic: `${checkbox.name}`,
				isSubscribed: false

			})
		})

		mindbox("async", {
			operation: "UnidragonEditCustomerDataFrontEu",
			data: this.updatedSubscribtions,
			onSuccess: this.onSuccess()
		});
	}

	onSuccess() {
		if (this.statusMessages) {
			this.topicsList.classList.add("hidden");
			this.statusMessages.classList.remove("hidden");
			this.statusMessages.classList.add("success");

			this.statusMessages.innerHTML = "Form submit successfully"
		}

		if (this.submitButton){
			this.submitButton.disabled = true;
		}
	}

	getTicket() {
		this.ticket = new URL(document.location.href).searchParams.get("ticket");
	}

	getSubscribtions() {
		if (!this.ticket) {
			return null;
		}
		mindbox("sync", {
			operation: "Unidragon.GetCustomerDataEu",
			data: {
				customer: {
					authenticationTicket: this.ticket
				}
			},
			onSuccess: (response) => {
				const subscriptions = response.customer.subscriptions;

				this.buildSubscribtionForm(subscriptions)
			},
			onError(err) {
				console.log("inside err")
			}
		});
	}

	buildSubscribtionForm(subscriptions) {
		const checkboxTemplate = this.querySelector("template");
		this.checkboxHtml = checkboxTemplate.innerHTML;
		let subscriptionsFound = false;

		if (!this.topicsList) {
			return null;
		}

		subscriptions.forEach(subscription => {
			if (subscription.pointOfContact === "Email" && subscription.isSubscribed) {
				const topic = this.topicNames[subscription.topic]

				if (topic) {
					let topicCheckbox = this.checkboxHtml;
					topicCheckbox = topicCheckbox.replaceAll("[[id]]", subscription.topic);
					topicCheckbox = topicCheckbox.replaceAll("[[name]]", subscription.topic);
					topicCheckbox = topicCheckbox.replace("[[label-text]]", topic);
					subscriptionsFound = true;

					this.topicsList.innerHTML += topicCheckbox;
				}
			}
		})

		if (!subscriptionsFound) {
			this.topicsList.classList.add("hidden");
			this.statusMessages.classList.remove("hidden");
			this.statusMessages.innerHTML = "You are not subscribed to the newsletter"

			if (this.submitButton){
				this.submitButton.classList.add("hidden");
				this.submitButton.disabled = true;
			}
		}
	}
}

if (!customElements.get("unsubscribe-mindbox-form")){
	customElements.define("unsubscribe-mindbox-form", UnsubscribeMindboxForm)
}
